(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('SuperBillSearch', SuperBillSearch);

    SuperBillSearch.$inject = ['$resource'];

    function SuperBillSearch($resource) {
        var resourceUrl =  'api/_search/super-bills/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
